import { render, staticRenderFns } from "./SelectWares.vue?vue&type=template&id=5b2b471b&scoped=true&"
import script from "./SelectWares.vue?vue&type=script&lang=js&"
export * from "./SelectWares.vue?vue&type=script&lang=js&"
import style0 from "./SelectWares.vue?vue&type=style&index=0&id=5b2b471b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2b471b",
  null
  
)

export default component.exports